<template>
    <div id="app">
        <RouterView/>
        <!-- 在线客服悬浮组件 -->
        <CustomerServiceComponent/>
    </div>
</template>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

body {
    margin: 0;
}

.el-main:nth-child(2) {
    padding-top: 173px !important;
}

/* loading加载icon颜色修改 */
.el-loading-spinner .path {
    stroke: #ec6c00 !important;
}

/* loading加载文字颜色修改 */
.el-loading-text {
    color: #ec6c00 !important;
}

/* el-radio-group 鼠标悬停时颜色 */
.el-radio-button__orig-radio:checked+.el-radio-button__inner:hover {
    color: #FFFFFF !important;
}
.el-radio-button__inner:hover {
    color: #ec6c00 !important;
}

/* cascader */
.el-cascader .el-input .el-input__inner:focus, .el-cascader .el-input.is-focus .el-input__inner {
    border-color: #ec6c00 !important;
}

.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path {
    color: #ec6c00 !important;
}

/* radio */
.el-radio__input.is-checked .el-radio__inner {
    border-color: #ec6c00 !important;
    background: #ec6c00 !important;
}

.el-radio__input.is-checked + .el-radio__label {
    color: #ec6c00 !important;
}
.el-radio-button__orig-radio:checked+.el-radio-button__inner{
    background-color: #ec6c00 !important;
    border-color: #ec6c00 !important;
    box-shadow: -1px 0 0 0 #ec6c00 !important;
}
.el-button:focus, .el-button:hover{
    color: #FFFFFF !important;
    background-color: #ec6c00 !important;
    border-color: #ffaf73 !important;
}

/* 分页 */
.el-pager li.active {
    color: #ec6c00 !important;
}
.el-pager li:hover {
    color: #ec6c00 !important;
}
.el-pagination__sizes .el-input .el-input__inner:hover{
    border-color: #ec6c00 !important;
}
.el-range-editor.is-active, .el-range-editor.is-active:hover, .el-select .el-input.is-focus .el-input__inner {
    border-color: #ec6c00 !important;
}
.el-select-dropdown__item.selected{
    color: #ec6c00 !important;
}
.el-select .el-input__inner:focus {
    border-color: #ec6c00 !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color: #ec6c00 !important;
    color: #FFFFFF !important;
}

.el-button--primary{
    background-color: #ec6c00 !important;
    border-color: #ec6c00 !important;
}
.el-button--primary.is-plain{
    color: #FFFFFF !important;
}
</style>
<script>
import CustomerServiceComponent from '@/components/CustomerServiceComponent'

export default {
    name: 'App',
    components: {
        CustomerServiceComponent
    },
    mounted() {
        document.title = '百润茂轴承商城'
        // 确保应用加载时显示首页
        if (this.$route.path !== '/') {
            this.$router.push('/')
        }
    }
}
</script>